export default "__VITE_ASSET__3bd94026__"